import { InjectionToken } from '@angular/core';

export interface NotificationBarData {
  icon?: string;
  iconColor?: string;
  message: string;
  primaryButtonText?: string;
  closeOnNavigation?: boolean;
}

export const NOTIFICATION_BAR_DATA = new InjectionToken<NotificationBarData>(
  'Data provided to notification bar'
);

export const DefaultNotificationBardData = {
  iconColor: 'grayMedium',
  message: 'No message provided',
};
